export default entity => {
  const { title, displayId } = entity;
  const userFriendlyId = displayId ? `#${displayId}` : displayId;
  let name = '';
  if (userFriendlyId) {
    name += `${userFriendlyId} - `;
  }
  name += title;
  return name;
};
